<div class="forgot-shell">
  <div class="forgot-card">
    <div class="forgot-main">
      <section class="forgot-left">
        <div class="forgot-content">
          <div class="forgot-header">
            <div class="forgot-icon-wrap" aria-hidden="true">
              <img class="forgot-icon" src="assets/images/lock.svg" alt="" />
            </div>

            <div class="forgot-title">
              <span class="forgot-title-light">{{ "userprofile.label.forgotMy" | translate }}</span>
              <span class="forgot-title-strong"> {{"userprofile.label.forgot.password" | translate }}</span>
            </div>

            <p class="forgot-subtitle" [innerHTML]="'userprofile.text.forgotPassword.instructions' | translate">
            </p>
          </div>

          <div class="forgot-form">

            @if (errors.length > 0) {
            <div class="notification-bar" role="alert" aria-live="assertive">
              <div class="login-error">
                <img class="icons-alert-circle" src="assets/images/alert-circle.svg" alt="Error" />
                <div class="message">
                  @for (error of errors; track $index) {
                  <li style="list-style: none" [innerHTML]="error"></li>
                  }
                </div>
              </div>
            </div>
            }
            @if (validationMessages && validationMessages.length > 0) {
            <app-validation-messages-panel [messages]="validationMessages">
            </app-validation-messages-panel>
            }
            <form class="forgot-form" (ngSubmit)="submit()" [formGroup]="forgotPasswordForm">
              <div class="forgot-field-container">
                <div class="forgot-field">
                  <app-standard-form-field label="userprofile.label.username" controlName="username" inputId="username"
                    [parentForm]="forgotPasswordForm" [required]="false" [disabled]="emailSent">
                  </app-standard-form-field>
                </div>

                <div class="forgot-field">
                  <app-standard-form-field label="userprofile.label.email" controlName="emailAddress"
                    inputId="emailAddress" [parentForm]="forgotPasswordForm" [required]="false" [disabled]="emailSent">
                  </app-standard-form-field>
                </div>
              </div>

              <button class="forgot-submit" type="submit" [disabled]="emailSent || loading"
                [ngClass]="{ 'is-disabled': emailSent || loading }">
                @if (loading) {
                <img class="login-loading-gif" src="assets/images/loading_new.gif" alt="Loading" />
                } @else {
                {{ "general.label.button.submit" | translate }}
                }
              </button>
            </form>
          </div>

          <div class="mt-3">
            <p>
              <a class="returnToLogin" [routerLink]="UrlConstants.loginUrl" [innerHTML]="'general.label.returnToLogin' | translate"></a>
            </p>
          </div>
        </div>
      </section>

      <!-- RIGHT: Image panel -->
      <aside class="forgot-right" aria-hidden="true">
        <img class="forgot-image" src="assets/images/CRC-Login-Image.jpg" alt="" />
      </aside>
    </div>

  </div>
</div>
